































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";
import SimpleDialogForm from "@/components/Forms/SimpleDialogForm.vue";
import { reaction } from "mobx";
import { Observer } from "mobx-vue";
import collectionIssueEditStore from "@/store/collectionIssueEditStore";
import CollectionIssueLetterHistoryEditStore from "@/store/collectionIssueLetterHistoryEditStore";
import { AddressSuggestionModel } from "../../api/AddressLookup";
import TextField from "@/components/Forms/TextField.vue";
import CollectionLetterHistory from "@/components/CollectionEvents/CollectionLetterHistory.vue";
import CollectionIssueLetterHistoryEditDialog from "@/components/CollectionIssueEvents/CollectionIssueLetterHistoryEditDialog.vue";

@Observer
@Component({ components: { ValidationProvider, SimpleDialogForm, TextField, CollectionLetterHistory, CollectionIssueLetterHistoryEditDialog } })
export default class CollectionIssueEditDialog extends Vue {
  @Prop(Boolean) readonly value: boolean = false;
  @Prop({ default: "" }) dataCy?: string;

  collectionIssueEditStore = collectionIssueEditStore;
  dispose?: () => void;

  async mounted() {
    this.dispose = reaction(
      () => this.collectionIssueEditStore.userTypedAddress,
      (typedAddress: string) => {
        if (typedAddress && typedAddress.trim().length > 2) {
          this.collectionIssueEditStore.fetchAddressSuggestions(typedAddress.trim());
        } else {
          this.collectionIssueEditStore.clearAddressSuggestions();
        }
      }
    );
  }

  handleCloseDialog() {
    collectionIssueEditStore.resetCollectionIssueEdit();
    if (CollectionIssueLetterHistoryEditStore.letterHistoryDeleted) {
      this.$emit("letterHistoryDeleted");
    }
    this.$emit("input", false);
  }

  updateCollectionIssue() {
    this.$emit("updateCollectionIssue");
  }

  showCollectionIssueLetterHistoryEditDialog() {
    this.$emit("showCollectionIssueLetterHistoryEditDialog");
  }

  getItemText(item: AddressSuggestionModel) {
    if (!item) return "";
    return `${item.addressLine1} ${item.suburb}`;
  }

  destroyed() {
    collectionIssueEditStore.resetCollectionIssueEdit();
    if (this.dispose) {
      this.dispose();
    }
  }
}
